var map = {
	"./cart.svg": 522,
	"./checkmark.svg": 427,
	"./chevron.svg": 289,
	"./close.svg": 228,
	"./email.svg": 0,
	"./facebook.svg": 724,
	"./instagram.svg": 628,
	"./linkedin.svg": 486,
	"./menu.svg": 333,
	"./person.svg": 47,
	"./phone.svg": 532,
	"./pin.svg": 693,
	"./search.svg": 492,
	"./x.svg": 352,
	"./youtube.svg": 203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 646;